<template>
  <CModal
    :title="title"
    :color="color"
    :show.sync="showModal"    
    class="basic-modal-color"
  >   
    <CForm id="event_code_form" method="POST" enctype="multipart/form-data">     
      <CInput
        hidden
        :lazy="false"
        :value.sync="$v.form.id.$model"
        name="id"
        id="id"          
      />       
      <CRow>              
        <CCol md="6">
          <CInput
            label="Código:"
            :lazy="false"
            :value.sync="$v.form.code.$model"
            name="code"
            id="code"
            placeholder=""
          />
        </CCol>    
        <CCol md="6">
          <CInput
            label="Consecutivo:"
            :lazy="false"
            :value.sync="$v.form.current.$model"
            name="current"
            id="current"
            type="text"
            placeholder=""
          />
        </CCol>    
      </CRow>            
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="store" :color="color">Guardar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minValue, helpers } from "vuelidate/lib/validators"
import store from '../../store';
import ws from '../../services/events_codes';

export default {
  name: 'EventCodeModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Editar Codigo",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async updateModal () {
      this.showModal = true;
      this.color = "success";
      this.title = 'Editar Código';
      this.isEdit = true;
      this.submitted = false;

      let response_code = await ws.get();
      if(response_code.type == "success"){
        this.form = {
          id: response_code.data.id,
          code: response_code.data.code,
          current: response_code.data.current,
        };
      }
    },
    async store () {
      this.$v.$touch();

      if (this.isValid) {
        this.loading();
        this.submitted = true;

        let form = document.getElementById("event_code_form");
        let formData = new FormData(form);
        let response = "";
        response = await ws.update(formData);         
        this.loaded();
        this.showToast(response.type, response.message);
        if(response.type == "success"){
          this.closeModal();
        }                              
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          code: '',
          current: '',
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {        
      },
      code: {        
      },
      current: {
        required,
        minValue: minValue(1)
      },
      
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
</style>